import { cn } from '@/lib/cn.ts';

type Props = {
  kicker?: string;
  title: string;
  description?: string;
  actions?: React.ReactNode;
  className?: string;
};

export function PageHeader({ kicker, title, description, actions, className }: Props) {
  return (
    <div className={cn('flex flex-wrap items-end justify-between gap-4', className)}>
      <div>
        {kicker && <p className="kicker mb-2">{kicker}</p>}
        <h1 className="font-display text-2xl font-medium tracking-tight">{title}</h1>
        {description && <p className="mt-1.5 text-sm text-text-muted">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
